<template>
    <v-app>
        <v-data-table :headers="headers" :items="packagingweights" :items-per-page="itemsPerPage"
            class="packagingweights-table" :server-items-length="total" :loading="loading"
            :options.sync="options" locale="de" :footer-props="footerProps" multi-sort>
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Verpackungsgewicht</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="500px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="success" class="mx-2" fab dark small v-bind="attrs" v-on="on" v-if="total == 0">
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-app-bar dark color="success">
                                <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                </v-card-title>
                            </v-app-bar>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-form ref="form" v-model="valid" lazy-validation>
                                            <v-row>
                                                <v-col cols="6">
                                                    <v-text-field v-model="editedItem.name"
                                                        label="Name"></v-text-field>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field v-model="editedItem.weight" label="Gewicht*" 
                                                        required type="number" min="0" step=".01"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field label="Beschreibung" v-model="editedItem.description"
                                                        hide-details="auto"></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-switch v-model="editedItem.lastAction"
                                                        :label="`Verpackungsgewicht ${editedItem.lastAction > 0 ? 'aktiviert' : 'deaktiviert'}`"
                                                        color="green"></v-switch>
                                                </v-col>
                                             </v-row>
                                        </v-form>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="error" text @click="close">
                                    Abbrechen
                                </v-btn>
                                <v-btn color="primary" @click="save" v-if="editedItem.weight" :disabled="!valid">
                                    Speichern
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            
            <template v-slot:item.lastAction="{ item }">
                <v-switch v-model="item.lastAction" color="green" disabled label=""></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mr-2" color="blue" v-bind="attrs" v-on="on" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                    </template>
                    <span>Bearbeiten</span>
                </v-tooltip>
            </template>
        </v-data-table>
    </v-app>
</template>
<script>
import axios from 'axios';
export default {
    props: {
        value: Array,
        editdata: null,
        url: {
            type: String,
            default: '/admin/packagingweight'
        },
        location_url: {
            type: String,
            default: '/admin/packagingweight/'
        },
        callback: {
            type: Function,
            default: () => ({})
        },
        catch: {
            type: Function,
            default: () => ({})
        },
        finally: {
            type: Function,
            default: () => ({})
        },
        submitBtnText: {
            type: String,
            default: "Speichern"
        },
        buttonClass: {
            type: String,
            default: "btn btn-primary"
        },
        inputClass: {
            type: String,
            default: "form-control-file"
        },
        validation: {
            type: Boolean,
            default: true,
        },

        tableSelectClass: {
            type: String,
            default: 'form-control'
        },
    },
    data: () => ({
        valid: true,
        messagedialog: false,
        dialog: false,
        disableOk: false,
        notificationconfigs: [],
        packagingweights: [],
        total: 0,
        itemsPerPage: 50,
        loading: true,
        conditions: [],
        filters: [],
        options: {
            page: 1,
            itemsPerPage: 50,
            // sortBy: 'DESC',
            sortDesc: [false],
            mustSort: false,
            multiSort: false,
            sort: '',
            filters: null
        },
       
        rules: [
            value => !!value || 'Erforderlich.',
            value => (value || '').length <= 50 || 'Max 50 characters',
            value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Ungültige E-Mail!'
            },
        ],
        headers: [
            { text: 'id', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Gewicht', value: 'weight' },
            { text: 'Beschreibung', value: 'description' },
            { text: 'Status', value: 'lastAction' },
            { text: 'Aktionen', value: 'actions', sortable: false },
        ],
        footerProps: {
            'items-per-page-options': [50, 500, 1000, -1],
            'show-current-page': true,
            'show-first-last-page': true,
            disableItemsPerPage: false,
            itemsPerPageText: 'Einträge pro Seite',
            itemsPerPageAllText: 'Alle',
        },

        editedItem: {
            id: 0,
            name: null,
            weight: null,
            type: null,
            description: null,
            lastAction: 1,
        },
        defaultItem: {
            id: 0,
            name: null,
            weight: null,
            type: null,
            description: null,
            lastAction: 1,
        },
    }),
    created() {
       
    },
    methods: {
        
        async getPackagingWeights() {
            this.loading = true
            this.options.sort = this.options.sortBy[0];
            axios.get('/admin/getpackagingweights/', { params: this.options })
                .then(function (response) {
                    console.log(response);
                    this.packagingweights = response.data;
                    this.total = response.data.total
                    this.itemsPerPage = response.data.per_page
                    this.loading = false
                }.bind(this));
        },
        
        editItem(item) {
            this.editedItem = item;
            this.dialog = true
        },

        close() {
            this.dialog = false,
                this.$nextTick(() => {
                    this.editedItem = this.defaultItem;
                })
        },

        save() {
            const _this = this;
            this.validate();
            if (this.editedItem.id > 0) {
                axios.put(this.url + '/' + this.editedItem.id,
                    this.editedItem,
                ).then(response => {
                    _this.callback(response);
                    this.showMsgBoxOne(response, true);
                }).catch(response => {
                    _this.catch(response);
                }).finally(response => {
                    _this.finally(response);
                });
            } else {
                axios.post(this.url,
                    this.editedItem,
                ).then(response => {
                    _this.callback(response);
                    this.showMsgBoxOne(response, true);
                }).catch(response => {
                    _this.catch(response);
                }).finally(response => {
                    _this.finally(response);
                });
            }
            // Hide the modal manually
            this.$nextTick(() => {
                // this.resetModal();
                this.$bvModal.hide('modal-prevent-closing')
            })
            this.close()
        },

        showMsgBoxOne(callback, change) {
            this.$bvModal.msgBoxOk(callback.data)
                .then(value => {
                    if (change) {
                        this.getPackagingWeights();
                    }
                })
                .catch(err => {
                    // An error occurred
                    console.log(err);
                })
        },
        validate() {
            this.$refs.form.validate()
        },

    },
    watch: {
        dialog(val) {
            val || this.close()
        },

        options(newValue, oldValue) {
            let cont = false
            if (oldValue.page !== newValue.page) cont = true
            if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
            if (oldValue.sortBy !== newValue.sortBy) cont = true
            if (oldValue.sortDesc !== newValue.sortDesc) cont = true
            if (cont) {
                this.getPackagingWeights();
            }
        },
    },
    computed: {
        formTitle() {
            return this.editedItem.id === 0 ? 'Verpackungsgewicht hinzufügen' : 'Verpackungsgewicht bearbeiten'
        },
    },
}

</script>